import { useEffect, useRef, useState } from 'react';
import { connect, useStore } from 'react-redux';
import useMedia from 'use-media';
import { BlackCheckBox } from '../../atoms/blackCheckBox';
import { Image } from '../../atoms/image';
import { Label } from '../../atoms/label';
// import { RadioBtn } from '../../atoms/radioBtn';
import { RadioButtonForm } from '../../molecules/radioButtonForm';
import { ModalCheckboxList } from '../../molecules/modalCheckboxList';
import arrow_bottom from '../../../resources/icons/ico_arrow_bottom.svg';
import arrow_top from '../../../resources/icons/ico_arrow_top.svg';
import { LabelInputForm } from '../../molecules/labelInputForm';
import { PullDownOptionForm } from '../../molecules/pullDownOptionForm';
import './../../../resources_membership_hotel/css/hotel/membership_crawl_modal.css';
import CommonUtil from '../../../common/commonUtil';
import { getPrefectureList, getKaiinInfoCrawl, getShisetsuGradeList, getFacilityInfo } from '../../../const';
import common from '../../../resources/js/common/common';
import CommonValidation from '../../../common/commonValidation';
import { ErrorMassage } from '../../molecules/errorMassage';
import messageConst from '../../../const/messageConst';
import { useHistory } from 'react-router-dom';

const CrawlPopupContainer = (props) => {
    const {
        state,
        resvKaiinken,
        setResvKaiinken,
        onClickClosePopupWindow,
        onClickOpenSenyuubiWindow,
        room,
        adultNum,
        childNum,
        membershipSearchParam,
        setMembershipSearchParam,
        membershipFacility,
        setMembershipFacility,
        setGrade,
        setPlanConditions,
        setFood,
        setPrivilegedService,
        setCheckIn,
        setCheckOut,
        setAdultNum,
        setChildNum,
        setRoom,
        crawlMember
    } = props;
    const store = useStore();

    let popupFlg = state.crawlPopup;
    let crawlPopupMode = state.crawlPopupMode;

    const history = useHistory();

    const useMediaFlag = useMedia({ maxWidth: '480px' });
    const [isMobilePhone, setIsMobilePhone] = useState(false);
    const [prefectureList, setPrefectureList] = useState([]);
    const [shisetsuList, setShisetsuList] = useState([]);
    const [resultFlg, setResultFlg] = useState(false);
    const [kaiinInfoList, setKaiinInfoList] = useState([]);
    const [kaiinkenNumber, setKaiinkenNumber] = useState('1');

    const popupRef = useRef(null);

    // エラー情報
    const [errorInfo, setErrorInfo] = useState({ errorMessageBox: [], errorFlg: false, });
    const [flgList, setFlgList] = useState(false);
    const [temporaryErrorInfo, setTemporaryErrorInfo] = useState({ errorMessage: '', errorFlg: false, });

    useEffect(() => {
        if (useMediaFlag) {
            setIsMobilePhone(true);
        } else {
            setIsMobilePhone(false);
        }
    }, [useMediaFlag]);

    // API呼出等事前処理
    useEffect(() => {
        // 都道府県一覧取得
        common.doPost(getPrefectureList, {}, afterGetPrefectureList);
        // 施設・グレード一覧取得
        common.doPost(getShisetsuGradeList, {}, afterGetShisetsuGradeList);
    }, []);

    /**
     * 都道府県一覧取得後処理
     * @param {any} res APIレスポンス
     */
    const afterGetPrefectureList = (res) => {
        const data = res.data;
        if (data.resultCode != 0) {
            setTemporaryErrorInfo({
                errorMessage: data.errorMessage,
                errorFlg: true,
            });
        } else {
            setPrefectureList(CommonUtil.getSelectList(data.prefectureList, 'prefectureCd', 'prefectureName', true, '選択する'));
        }
    }

    /**
     * 施設・グレード一覧取得後処理
     * @param {any} res APIレスポンス
     */
    const afterGetShisetsuGradeList = (res) => {
        const data = res.data;
        if (data.resultCode != 0) {
            setTemporaryErrorInfo({
                errorMessage: data.errorMessage,
                errorFlg: true,
            });
        } else {
            const list = [];
            data.shisetsuInfo.memberHotelList.forEach(mh => {
                mh.shisetsuList.forEach(sh => {
                    list.push({ id: sh.shisetsuCd, name: sh.shisetsuName });
                });
            });
            setShisetsuList(CommonUtil.getSelectList(list, 'id', 'name', true, '選択する'));
        }
    }

    /**
     * 検索押下処理
     */
    const onClickSearch = () => {
        document.getElementById('btnSearch').disabled = true;
        setErrorInfo({ errorMessage: [], errorFlg: false });
        // バリデーションチェック
        let errMsgs = [];
        let flgList = {
            errorKaiinName: false,
            errorKaisyaName: false,
            errorShisetsu: false,
            errorPrefecture: false,
        };
        // 会員名／会社名
        const kaiinName = document.getElementById('kaiinName').value;
        const kaisyaName = document.getElementById('kaisyaName').value;
        let errMsg = kaiinName && kaisyaName ? '会員名／会社名は一方だけ入力可能です。' :
            !kaiinName && !kaisyaName ? '会員名／会社名のどちらかは入力必須です。' : '';
        if (errMsg) {
            flgList.errorKaiinName = true;
            flgList.errorKaisyaName = true;
            errMsgs.push(errMsg);
        }
        errMsg = '';
        if (CommonValidation.NameKanaSLC(kaiinName)) {
            flgList.errorKaiinName = true;
            errMsg = messageConst.HANKAKU_KANA_ERROR;
        }
        if (CommonValidation.NameKanaSLC(kaisyaName)) {
            flgList.errorKaisyaName = true;
            errMsg = messageConst.HANKAKU_KANA_ERROR;
        }
        if (errMsg) {
            errMsgs.push(errMsg);
        }
        // 契約施設
        const shisetsuCd = document.getElementById('shisetsu').value;
        if (CommonValidation.Require(shisetsuCd)) {
            flgList.errorShisetsu = true;
            errMsgs.push(messageConst.FACILITY_ERROR);
        }
        // 都道府県
        const prefectureCd = document.getElementById('prefecture').value;
        if (CommonValidation.Require(prefectureCd)) {
            flgList.errorPrefecture = true;
            errMsgs.push('都道府県を選択してください。');
        }
        // エラー表示
        setFlgList(flgList);
        if (errMsgs.length) {
            setResultFlg(false);
            setErrorInfo({
                errorMessage: errMsgs,
                errorFlg: true,
            });
            document.getElementById('btnSearch').disabled = false;
        } else {
            // 検索実施
            const pref = prefectureList.find((v) => {
                return v.id == prefectureCd;
            });
            const req = {
                kaiinName: kaiinName,
                kaisyaName: kaisyaName,
                shisetsuCd: shisetsuCd,
                prefectureName: pref.value,
            }
            common.doPost(getKaiinInfoCrawl, req, afterGetKaiinInfoCrawl);
            document.getElementById('btnSearch').disabled = false;
        }
    }

    /**
     * 会員一覧取得取得後処理
     * @param {any} res APIレスポンス
     */
    const afterGetKaiinInfoCrawl = (res) => {
        const data = res.data;
        if (data.resultCode != 0) {
            setErrorInfo({
                errorMessage: [data.errorMessage],
                errorFlg: true
            });
            setResultFlg(false);
        } else if (data.kaiinInfoList?.length) {
            setKaiinInfoList(data.kaiinInfoList);
            setResultFlg(true);
            popupRef.current.scrollIntoView({ block: "start", behavior: 'smooth' });
        } else {
            setErrorInfo({
                errorMessage: ['検索結果は0件です。'],
                errorFlg: true,
            });
            setResultFlg(false);
        }
    }

    /**
     * 選択押下処理
     */
    const onClickSelect = () => {
        document.getElementById('btnSelect').disabled = true;
        let err = true;
        const radioGr = document.getElementsByName('kaiinInfo');
        let keiyakuNo = "";
        let refKaiinInfo = {};
        radioGr.forEach(radio => {
            if (radio.checked) {
                const kaiin = kaiinInfoList.find((v) => {
                    return v.kaiinNo == radio.value;
                });
                kaiin.resvKaiinken[0].selected = true;
                kaiin.resvKaiinken[0].memberCd = crawlMember.user_cd;
                keiyakuNo = kaiin.resvKaiinken[0].keiyakuNo;
                refKaiinInfo = {
                    keiyakuNo: kaiin.resvKaiinken[0].keiyakuNo,
                    kaiinkenCd: kaiin.resvKaiinken[0].id,
                    kaiinkenNo: kaiin.resvKaiinken[0].value,
                    riyoKaiinkenSyubetCd: kaiin.resvKaiinken[0].riyoKaiinkenSyubetCd,
                };
                setResvKaiinken(kaiin.resvKaiinken);
                onClickClosePopupWindow();
                err = false;
            }
        });
        if (err) {
            setErrorInfo({
                errorMessage: ['会員を選択してください。'],
                errorFlg: true
            });
        } else {
            // ユーザ入力情報クリア
            store.dispatch({ type: "INPUT_USER_INFO", payload: { inputUserInfo: {} } });
            // 施設・部屋グレード情報取得
            common.doPostRef(getFacilityInfo, { keiyakuNo: keiyakuNo }, refKaiinInfo, afterGetFacilityInfo);
        }
        document.getElementById('btnSelect').disabled = false;
    };

    // 施設・部屋グレード情報取得後処理
    const afterGetFacilityInfo = (res, ref) => {
        const data = res.data;
        if (data.resultCode == 0) {
            let memberHotelList = [];
            data.shisetsuInfo.memberHotelList.forEach(main => {
                let list = [];
                main.shisetsuList.forEach(membership => {
                    let membershipObj = {}
                    if (membership.enable && membershipFacility.membership.find(m => m.mainGroupCd === main.mainGroupCd).shisetsuList.find(s => s.id === membership.shisetsuCd).checked) {
                        membershipObj = { class: "facility", id: membership.shisetsuCd, value: membership.shisetsuName, checked: true, disabled: !membership.enable, openFlg: membership.openFlg, openingDate: membership.openingDate }
                    } else {
                        membershipObj = { class: "facility", id: membership.shisetsuCd, value: membership.shisetsuName, checked: false, disabled: !membership.enable, openFlg: membership.openFlg, openingDate: membership.openingDate }
                    }
                    list.push(membershipObj);
                })
                let mainBuildingObj =
                {
                    mainGroupCd: main.mainGroupCd,
                    mainGroupName: main.mainGroupName,
                    checked: false,
                    displayFlg: false,
                    disabled: main.honkanShisetsuRiyoFlg,
                    shisetsuList: list
                };
                memberHotelList.push(mainBuildingObj);
            })

            // let generalHotelList = [];
            // data.shisetsuInfo.generalHotelList?.forEach(main => {
            //     let list = [];
            //     main.shisetsuList.forEach(ippan => {
            //         let ippanObj = { class: "facility", id: ippan.shisetsuCd, value: ippan.shisetsuName, checked: false, disabled: !ippan.enable }
            //         list.push(ippanObj);
            //     })
            //     let mainBuildingObj =
            //     {
            //         mainGroupCd: main.mainGroupCd,
            //         mainGroupName: main.mainGroupName,
            //         checked: false,
            //         displayFlg: false,
            //         disabled: false,
            //         shisetsuList: list
            //     };
            //     generalHotelList.push(mainBuildingObj);
            // })
            // setMembershipFacility({ membership: memberHotelList, ippan: generalHotelList });

            if (crawlPopupMode == "search") {
                const facilityId = membershipSearchParam.shisetsuCdList?.[0];
                memberHotelList.forEach(group => {
                    group.shisetsuList.forEach(item => {
                        if (item.id === facilityId) {
                            item.checked = true;
                        } else {
                            item.checked = false;
                        }
                    })
                })
                setMembershipFacility({ membership: memberHotelList, ippan: [] });

                let grades = [];
                data.roomGradeList.forEach(value => {
                    let item = { class: "gradeList", id: value.gradeCd, value: value.gradeName, checked: false, disabled: !value.enable }
                    grades.push(item);
                })
                setGrade(grades);

                let planConditionsList = [];
                data.planConditionsList.forEach(value => {
                    let item = { class: "planConditions", id: value.planConditionsCd, value: value.planConditionsName, checked: false, disabled: !value.enable }
                    planConditionsList.push(item);
                })
                setPlanConditions(planConditionsList);

                let foodList = [];
                data.foodList.forEach(value => {
                    let item = { class: "foodList", id: value.foodCd, value: value.foodName, checked: false, disabled: !value.enable }
                    foodList.push(item);
                })
                setFood(foodList);

                let privilegedServiceList = [];
                data.privilegedServiceList.forEach(value => {
                    let item = { class: "privilegedService", id: value.privilegedServiceCd, value: value.privilegedServiceName, checked: false, disabled: false, description: value.privilegedServiceText }
                    privilegedServiceList.push(item);
                })
                setPrivilegedService(privilegedServiceList);

                // 大人人数
                let newAdultNum = [...adultNum]
                newAdultNum.forEach((data) => {
                    if (data.id == membershipSearchParam.adultCnt) {
                        data.selected = true;
                    } else {
                        data.selected = false;
                    }
                })
                setAdultNum(newAdultNum);

                // 子供人数
                let newChildNum = [...childNum]
                newChildNum.forEach((data) => {
                    if (data.id == membershipSearchParam.childCnt) {
                        data.selected = true;
                    } else {
                        data.selected = false;
                    }
                })
                setChildNum(newChildNum);

                // 部屋数
                let newRoom = [...room]
                newRoom.forEach((data) => {
                    if (data.id == membershipSearchParam.roomCnt) {
                        data.selected = true;
                    } else {
                        data.selected = false;
                    }
                })
                setRoom(newRoom);

                setMembershipSearchParam({
                    ...membershipSearchParam,
                    keiyakuNo: ref.keiyakuNo,
                    kaiinkenCd: ref.kaiinkenCd,
                    kaiinkenNo: ref.kaiinkenNo,
                    riyoKaiinkenSyubetCd: ref.riyoKaiinkenSyubetCd,
                });
                setCheckIn(CommonUtil.getDateFromString(membershipSearchParam.checkInDate, "-"));
                setCheckOut(CommonUtil.getDateFromString(membershipSearchParam.checkOutDate, "-"));
                history.push("/reserve/hotel/searchResult");
            } else if (crawlPopupMode == "senyuubi") {
                onClickOpenSenyuubiWindow(ref.keiyakuNo);
            } else {
                setMembershipFacility({ membership: memberHotelList, ippan: [] });
            }
        }
    }

    return (
        <div className={popupFlg ? 'popupIsShow' : 'popup'} id='js-popup'>
            <div className='popupInner'>
                <div className='closeBtn' id='js-close-btn' onClick={onClickClosePopupWindow}>
                </div>
                <h4 className='popupInnerText' >{state.popupTitle}</h4>
                <div style={errorInfo.errorFlg ? styles.errorDiv : { display: 'none' }}>
                    <ErrorMassage data={errorInfo.errorMessage} />
                </div>
                <LabelInputForm
                    label='会員名'
                    id='kaiinName'
                    placeholder='リゾートトラスト'
                    className={flgList.errorKaiinName ? 'inputKeywordError' : 'inputKeyword'}
                    wrapClassName='crawlModalInputLong'
                />
                <LabelInputForm
                    label='会社名'
                    id='kaisyaName'
                    placeholder='リゾートトラスト'
                    className={flgList.errorKaisyaName ? 'inputKeywordError' : 'inputKeyword'}
                    wrapClassName='crawlModalInputLong'
                />
                <div className='crawlModalInputLong'>
                    <PullDownOptionForm
                        title={'契約施設'}
                        id='shisetsu'
                        selectClass={flgList.errorShisetsu ? 'errorPullDownOptionStyle' : 'pullDownOptionStyle'}
                        data={shisetsuList}
                    />
                </div>

                <div className='crawlModalWrap'>
                    <div className='crawlModalInputShort'>
                        <PullDownOptionForm
                            title={'都道府県'}
                            id='prefecture'
                            selectClass={flgList.errorPrefecture ? 'inputPullDownButtonError' : 'inputPullDownButton'}
                            data={prefectureList}
                        />
                    </div>
                    <button ref={popupRef} id='btnSearch' className='button crawlButton' onClick={onClickSearch}>検索</button>
                </div>

                <div className='crawlUserListBox' style={resultFlg ? { display: 'block' } : { display: 'none' }}>
                    <div className='crawlUserListWrapHeader'>
                        <div className='crawlUserCheck'></div>
                        <div className='crawlUserList'>
                            <div className='crawlUser'>
                                <div className='userNum'>会員番号</div>
                                <div className='userAddress'>住所</div>
                                <div className='userGroup'>グレード</div>
                            </div>
                            <div className='crawlUser ntbboder'>
                                <div className='userName'>会員名</div>
                                <div className='userCompany'>会社名</div>
                            </div>
                        </div>
                    </div>
                    {kaiinInfoList ? kaiinInfoList.map((kaiinInfo, kaiinindex) =>
                        <div className='crawlUserListWrap' key={kaiinindex}>
                            <div className='crawlUserCheck'>
                                <input
                                    type="radio"
                                    id={'kaiinInfo_' + kaiinindex}
                                    value={kaiinInfo.kaiinNo}
                                    name='kaiinInfo'
                                    className="crawlUserRadio"
                                />
                            </div>
                            <div className='crawlUserList'>
                                <div className='crawlUser'>
                                    <div className='userNum'>{kaiinInfo.kaiinNo}</div>
                                    <div className='userAddress'>
                                        {kaiinInfo.address?.length > 10 ? (kaiinInfo.address.substring(0, 10) + "…") : kaiinInfo.address}
                                    </div>
                                    <div className='userGroup'>{kaiinInfo.keiyakuGrade}</div>
                                </div>
                                <div className='crawlUser ntbboder'>
                                    <div className='userName'>{kaiinInfo.kaiinName}</div>
                                    <div className='userCompany'>{kaiinInfo.kaisyaNamKj}</div>
                                </div>
                            </div>
                        </div>
                    ) : null}
                </div>
                <div className='buttonArea' style={resultFlg ? { display: 'block' } : { display: 'none' }}>
                    <button id='btnSelect' className='button' onClick={onClickSelect}>選択</button>
                </div>
            </div>
            <div className='blackBackground' id='js-black-bg'></div>
        </div >
    );
};

const mapStateToProps = (state) => {
    return {
        planConditions: state.planConditions,
        grade: state.grade,
        food: state.food,
        privilegedService: state.privilegedService,
        room: state.room,
        adultNum: state.adultNum,
        childNum: state.childNum,
        membershipFacility: state.membershipFacility,
        resvKaiinken: state.resvKaiinken,
        membershipSearchParam: state.membershipSearchParam,
        crawlMember: state.crawlMember,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setPlanConditions: (item) => {
            dispatch({ type: 'PLAN_CONDITIONS', payload: { planConditions: item } })
        },
        setPrivilegedService: (item) => {
            dispatch({ type: 'PRIVILEGED_SERVICE', payload: { privilegedService: item } })
        },
        setFood: (item) => {
            dispatch({ type: 'FOOD', payload: { food: item } })
        },
        setMembershipFacility: (item) => {
            dispatch({ type: 'MEMBERSHIP_FACILITY', payload: { membershipFacility: item } })
        },
        setGrade: (item) => {
            dispatch({ type: 'GRADE', payload: { grade: item } })
        },
        setDispFacility: (item) => {
            dispatch({ type: 'DISP_FACILITY', payload: { dispFacility: item } })
        },
        setDispDetailCondition: (item) => {
            dispatch({ type: 'DISP_DETAIL_CONDITION', payload: { dispDetailCondition: item } })
        },
        setResvKaiinken: (item) => {
            dispatch({ type: "RESV_KAIINKEN", payload: { resvKaiinken: item } })
        },
        setMembershipSearchParam: (item) => {
            dispatch({ type: "MEMBERSHIP_SEARCH_PARAM", payload: { membershipSearchParam: item } })
        },
        setCheckIn: (item) => {
            dispatch({ type: "CHECKIN", payload: { checkIn: item } })
        },
        setCheckOut: (item) => {
            dispatch({ type: "CHECKOUT", payload: { checkOut: item } })
        },
        setRoom: (item) => {
            dispatch({ type: "ROOM", payload: { room: item } })
        },
        setAdultNum: (item) => {
            dispatch({ type: "ADULT_NUM", payload: { adultNum: item } })
        },
        setChildNum: (item) => {
            dispatch({ type: "CHILD_NUM", payload: { childNum: item } })
        },
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(CrawlPopupContainer);

const styles = {
    divStyle: {
        display: 'flex',
        width: '80%',
        textAlign: 'left',
        alignContent: 'center',
        margin: '10px 5% 40px 5%',
        fontSize: 'small',
        flexWrap: 'wrap',
    },
    divStyleSp: {
        display: 'flex',
        flexWrap: 'wrap',
        textAlign: 'left',
        alignContent: 'center',
        padding: '20px 5%',
        fontSize: 'small',
        justifyContent: 'space-between',
    },
    divItemStyle: {
        display: 'flex',
        flexWrap: 'wrap',
        width: '33%',
        textAlign: 'left',
        alignContent: 'center',
        fontSize: 'small'
    },
    divItemStyleSp: {
        width: '48%',
        textAlign: 'left',
        margin: '0px 0px 20px 0px',
    },
    divFacilityStyle: {
        display: 'flex',
        flexWrap: 'wrap',
        width: '100%',
        textAlign: 'left',
        alignContent: 'center',
        fontSize: 'small'
    },
    divFacilityStyleSp: {
        width: '48%',
        textAlign: 'left',
        margin: '0px 0px 20px 0px',
    },
    divItemTitleStyle: {
        padding: '10px 0% 10px 5%',
        color: '#696969',
        justifyContent: 'left',
    },
    divItemTitleStyleSp: {
        textAlign: 'left',
        padding: '10px 0% 10px 5%',
        color: '#696969',
    },
    none: {
        display: 'none'
    },
    errorMassage: {
        display: 'inline-block',
        textAlign: 'left',
        padding: '15px 0px 0px 0px',
    },
    errorDiv: {
        display: 'block',
        color: 'red',
        textAlign: 'center',
        fontSize: '0.8rem',
        background: 'rgba(255,255,255,0)',
        border: 0,
        fontWeight: 'bold'
    }
}
